// extracted by mini-css-extract-plugin
export var desc = "PageFooter-module--desc--fpsjs";
export var img = "PageFooter-module--img--ozoHE";
export var lineLink = "PageFooter-module--line-link--kHR0z";
export var lineLink_black = "PageFooter-module--line-link_black--nf-HA";
export var lineLink_grey = "PageFooter-module--line-link_grey--SB3do";
export var lineLink_primary = "PageFooter-module--line-link_primary--ZyFil";
export var lineLink_secondary = "PageFooter-module--line-link_secondary--Jre1z";
export var lineLink_white = "PageFooter-module--line-link_white--jQSnW";
export var section = "PageFooter-module--section--yVPbg";
export var top = "PageFooter-module--top--6-oG6";